import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserModel} from "../../../models/user.model";
import { Router} from "@angular/router";
import {UserService} from "../../../services/user.service";
import {Observable, Subscription} from "rxjs";
import {GoogleAnalyticsService} from "ngx-google-analytics";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {ConfigService} from "../../../services/config.service";
import {ModalService} from "../../../services/modal.service";


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  brandName;
  assetsSource;
  logoFileName;
  logoAltText;
  isRival;

  user!: UserModel | null;  //needed because of the currency
  userSubs: Subscription;
  balance!: number | null;
  balanceSubs: Subscription;

  hasMinReg: boolean;

  openedModal$? : Observable<string | null>;



  @Output() sidebarToggleEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() sidebarToggled: boolean = false;


  constructor(
    private configs: ConfigService,
    private userService: UserService,
    private router: Router,
    private gaService: GoogleAnalyticsService,
    private trackingService: TrackingHelperService,
    private modalService: ModalService
  ) {
    this.isRival = this.configs.isRivalCasino;
    this.brandName = this.configs.brandName;
    this.hasMinReg = this.configs.hasMinimalRegistration;
    this.assetsSource = this.configs.assetsPath;
    this.logoFileName = this.configs.logoName;
    this.logoAltText = this.configs.logoAltText;

    this.userSubs = this.userService.userObject.subscribe( userData => {
      this.user = userData;
    })

    this.balanceSubs = this.userService.balanceObject.subscribe( balance => {
      this.balance = balance;
    })

    this.openedModal$ = this.modalService.openModal$;

  }


  ngAfterViewInit(): void {
    // for landings - toggle registration in instantplay routes when they click on old landings
    const currentUrl = this.router.url;
    if(currentUrl.includes('instantplay') || currentUrl.includes('register') || currentUrl.includes('x=registration')){
      //to prevent "Expression has changed after it was checked" error in dev mode: https://blog.angular-university.io/angular-debugging/
      setTimeout(() => {
        this.openModal(this.hasMinReg ? 'minSignUpModal': 'signUpModal');
        //send event to GA
        this.gaService.event('register_page_loaded', undefined, undefined, undefined, undefined,{play_mode: "real", ...this.trackingService.getAffiliateOptions() });
      });
    }
  }


  goToCashier(){
    this.router.navigate(['account', 'cashier'])
  }


  toggleSidebar(){
    this.sidebarToggled = !this.sidebarToggled;
    this.sidebarToggleEvent.emit(this.sidebarToggled);
  }


  openModal(modalId: string){
    this.modalService.open(modalId);
  }

  ngOnDestroy(){
    this.userSubs?.unsubscribe();
    this.balanceSubs?.unsubscribe();
  }


}

